var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 184,
    viewBox: "0 0 230 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30164 70.767C7.30164 70.767 103.037 203.195 222.698 68.306C103.037 -66.5829 7.30164 70.767 7.30164 70.767Z",
    fill: "#FFF9EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115 115.141C146.097 115.141 171.306 89.8687 171.306 58.694C171.306 27.5192 146.097 2.24707 115 2.24707C83.9027 2.24707 58.6935 27.5192 58.6935 58.694C58.6935 89.8687 83.9027 115.141 115 115.141Z",
    fill: "#47CBA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115 87.0573C130.587 87.0573 143.223 74.3584 143.223 58.6934C143.223 43.0285 130.587 30.3296 115 30.3296C99.4126 30.3296 86.7765 43.0285 86.7765 58.6934C86.7765 74.3584 99.4126 87.0573 115 87.0573Z",
    fill: "#4200FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3511 76.6667C6.00781 76.6625 4.69116 76.2909 3.54332 75.5919C2.39548 74.8929 1.46007 73.893 0.838082 72.7003C0.216094 71.5076 -0.0688448 70.1673 0.0140574 68.8242C0.0969597 67.4811 0.544551 66.1862 1.30848 65.0793C3.05177 62.5896 44.5139 3.95685 108.497 0.180946C149.5 -2.179 189.773 18.5531 228.149 61.917C229.444 63.3816 230.105 65.3015 229.986 67.2544C229.868 69.2073 228.981 71.0331 227.519 72.3303C226.057 73.6274 224.14 74.2897 222.191 74.1713C220.241 74.0529 218.418 73.1636 217.124 71.699C181.928 31.9222 145.696 12.7948 109.452 14.8952C52.6532 18.1637 13.7825 72.938 13.4055 73.4925C12.7255 74.4703 11.8201 75.2693 10.7661 75.8219C9.71215 76.3745 8.54068 76.6643 7.3511 76.6667Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.917 159.262L115.357 140.784L102.863 159.22C100.651 162.32 99.6667 166.126 100.1 169.907C100.534 173.687 102.354 177.174 105.21 179.694C111.052 184.868 119.846 184.886 125.666 179.738C128.513 177.211 130.32 173.72 130.737 169.94C131.155 166.16 130.153 162.36 127.925 159.275L127.917 159.262Z",
    fill: "#001F73"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkEye);
export default __webpack_public_path__ + "static/media/DarkEye.d75d61e6.svg";
export { ForwardRef as ReactComponent };